import { Grid } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Back from "../components/Back";
import CardDetails from "../components/CardDetails";
import LoadingPage from "../components/LoadingPage";
import Menu from "../components/Menu";
import { baseService } from "../helpers/baseService";
import { config } from "../helpers/config";
import { setTitle } from "../helpers/title";

export default function InboxDetail() {
  const { id } = useParams();
  const [loadingPage, setLoadingPage] = useState(false);
  const [inboxDetail, setInboxDetail] = useState({});

  useEffect(() => {
    setLoadingPage(true);
    baseService.get(
      config.services.event.getInboxByID + id,
      (res) => {
        setInboxDetail(res.data);
        setTitle(`${res.data.eventDetail.eventName} | Inbox Detail`);
      },
      (err) => {
        console.log(err);
      }
    );
    setLoadingPage(false);
  }, [id]);

  return (
    <div>
      <div className="container" />
      <Back title="Detail Tiket" />
      <div className="content">
        {loadingPage && Object.keys(inboxDetail).length === 0 ? (
          <LoadingPage />
        ) : (
          <Grid placeItems="center" minHeight="var(--page-height)">
            {Object.keys(inboxDetail).length > 0 ? (
              <CardDetails data={inboxDetail} />
            ) : (
              <div>tidak ada data</div>
            )}
          </Grid>
        )}
      </div>
      <Menu />
    </div>
  );
}
